import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';

@NgModule({
  imports: [IconComponent],
  exports: [IconComponent]
})
export class IconModule {}
